import React, { useState } from "react";
import { Flex, Box, Link } from "rebass/styled-components";
import { FloatingContainer, FloatingContent } from "../Wrappers";
import { Body } from "../Text";
import Lottie from "lottie-react";
import Security from "../../../animations/security.json";
import { useUser } from "../../Hooks/useUser";
import { useRecoilValue } from "recoil";
import { StripePaystationState } from "../../State";
import styled from "styled-components";
import { StripeCheckout } from "./Checkout";

const lottieStyle = {
  height: 180,
};
export const Stripe: React.FC = () => {
  const [state] = useState({
    loading: true,
    error: false,
  });
  const paystation = useRecoilValue(StripePaystationState);
  const { allstarUser } = useUser();

  if (state.error || (!paystation.lookUp && !paystation.type)) {
    return (
      <FloatingContainer>
        <FloatingContent
          title={
            <Flex justifyContent="center" fontSize="75px" pb={[6]}>
              <span role="img" aria-label="">
                🤔
              </span>
            </Flex>
          }
          body={
            <Body>
              Something went wrong. Contact support for further assistance.
            </Body>
          }
        />
      </FloatingContainer>
    );
  }
  if (paystation.type === "session") {
    return (
      <Box
        style={{
          paddingBottom: "56.25%",
          paddingTop: "35px",
          height: 0,
        }}
      >
        <IFrameLoading>
          <Flex
            justifyContent="center"
            alignItems={"center"}
            flexDirection="column"
          >
            <Lottie animationData={Security} style={lottieStyle} loop={true} />
            <ConnectionText>Establishing a secure connection</ConnectionText>
            <ConnectionSubText>
              Just a second... We're fetching the subscription and payment info
            </ConnectionSubText>
            {paystation.portalUrl && (
              <FallbackLink target="_blank" href={paystation.portalUrl}>
                If you aren't redirected, click here
              </FallbackLink>
            )}
          </Flex>
        </IFrameLoading>
      </Box>
    );
  }

  return (
    <StripeCheckout
      userToken={allstarUser.token}
      lookup={paystation.lookUp!}
      coupon={paystation.couponId}
      returnUrl={paystation.returnUrl || "/profile"}
    />
  );
};
type iFrameProps = {
  isMobile: boolean;
  paystationReady?: boolean;
};

const ConnectionText = styled(Flex)`
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  height: 100%;
  justify-content: center;
  margin-top: 20px;
  text-align: center;
`;

const ConnectionSubText = styled(Flex)`
  align-items: center;
  color: #8fa9af;
  font-size: 18px;
  font-weight: 400;
  height: 100%;
  justify-content: center;
  margin-top: 10px;
  text-align: center;
`;

const FallbackLink = styled(Link)`
  color: ${(props) => props.theme.colors.envy};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-top: 20px;
  text-decoration: underline;

  &:hover {
    color: ${(props) => props.theme.colors.ice};
  }
`;

const IFrameLoading = styled(Flex)`
  align-items: center;
  background: #1f2a33;
  border-color: transparent;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  left: 50%;
  min-height: 600px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 40vw;
  z-index: 10;

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    width: 90vw;
  }
`;
